import { render, staticRenderFns } from "./ViewAllRequest.vue?vue&type=template&id=22a3027a&scoped=true&"
import script from "./ViewAllRequest.vue?vue&type=script&lang=js&"
export * from "./ViewAllRequest.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllRequest.vue?vue&type=style&index=0&id=22a3027a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3027a",
  null
  
)

export default component.exports